module.exports = __webpack_public_path__ + "static/img/sidebar-9.1615a685.jpg";